import { createSelector } from 'reselect';

const getProductSales = state => state.productSales?.products;
const getProducts = state => state.products?.products;

export const hasDeliverableProducts = createSelector(
    [getProductSales, getProducts], (productSales, products) => {
        let result = false;
        Object.values(productSales || {}).forEach(productSale => {
            if (products[productSale.product_id]?.is_deliverable) {
                result = true;
            }
        });
        return result;
    }
);
